// Decimal-input helpers extracted from DraftFormPrimitives.tsx (#1749) so the
// draft-media capability owns the parse/format helpers `useDecimalTextInput`
// depends on. The remaining DraftFormPrimitives helpers (Field, Grid,
// parseQuantityInput, parseIntInput, formatIntInput, formatM3Display) stay in
// the requests feature.

export function parseDecimalInput(value: string): number {
  const normalized = value.trim().replace(',', '.');
  if (normalized === '') return 0;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

// WHY (#701): nullable value support — CONTAINER-kind item drafts may
//   carry null weight/volume. Render null as the empty-input sentinel,
//   identical to the zero handling for STANDARD drafts.
export function formatDraftDecimal(value: number | null): string {
  if (value === null) return '';
  return value === 0 ? '' : String(value);
}
